module.exports = __webpack_public_path__ + "img/Eye_purple_icon.3fa068f6.png";